import { upperFirst, lowerCase } from 'lodash';
import { api, checkForUnauthorized } from '@/utils';

import {
  ActivityAssigner,
  ActivityEvents,
  CargoInfo,
  ClientInfo,
  DossierAssigner,
  FormControls,
  GeneralDossierInfo,
  GenericFieldsInfo,
  TimeEstimationsInfo,
  StakeHolderReferences,
} from '@/components';

export default {
  name: 'InputForm',
  components: {
    [ActivityAssigner.name]: ActivityAssigner,
    [ActivityEvents.name]: ActivityEvents,
    [CargoInfo.name]: CargoInfo,
    [ClientInfo.name]: ClientInfo,
    [DossierAssigner.name]: DossierAssigner,
    [FormControls.name]: FormControls,
    [GeneralDossierInfo.name]: GeneralDossierInfo,
    [GenericFieldsInfo.name]: GenericFieldsInfo,
    [TimeEstimationsInfo.name]: TimeEstimationsInfo,
    [StakeHolderReferences.name]: StakeHolderReferences,
  },
  props: {},
  data: () => ({
    apiVersion: 1,
    inputForm: null,
    inputFormTypes: [],
    inputFormType: '',
    snackbar: false,
    snackbarMessage: '',
    ports: [],
    enums: [],
    products: [],
  }),
  computed: {
    inputFormTypesTweaked() {
      this.inputFormTypes.forEach((inputFormType) => {
        // eslint-disable-next-line
        inputFormType.label = upperFirst(lowerCase(inputFormType.type));

        inputFormType.fields.forEach((inputFormTypeField) => {
          // eslint-disable-next-line
          inputFormTypeField.label = upperFirst(lowerCase(inputFormTypeField.key));
          // eslint-disable-next-line
          inputFormTypeField.type = this.getInputType(inputFormTypeField.dataType);
          // eslint-disable-next-line
          inputFormTypeField.veevalidate = inputFormTypeField.mandatory ? 'required' : '';
        });
      });

      let itemsOrdered = [];

      if (this.inputFormTypes.length > 0) {
        const sortOrder = ['Dossier', 'Shipping agent', 'Cargo operations', 'Sampling', 'Analysis', 'Inspection', 'Port engine arrival', 'Port engine departure', 'Port engine log'];

        itemsOrdered = [...this.inputFormTypes.sort((a, b) => sortOrder.indexOf(a.label) - sortOrder.indexOf(b.label))];
      }
      return [...itemsOrdered];
    },
  },
  methods: {
    getInputFormTypes() {
      const url = '/input-types';

      api.get(url)
        .then((response) => {
          this.inputFormTypes = response.data;
        })
        .catch((error) => {
          checkForUnauthorized(error);
          console.log(error);
        });
    },
    getPorts() {
      // BASEURL
      const url = '/ports';

      api.get(url)
        .then((response) => {
          this.ports = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getEnums() {
      // BASEURL
      const url = '/enums';

      api.get(url)
        .then((response) => {
          this.enums = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getProducts() {
      // BASEURL
      const url = '/products';

      api.get(url)
        .then((response) => {
          this.products = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getInputType(dataType) {
      switch (dataType) {
        case 'LiquidString':
          return 'text';
        case 'LiquidInt':
        case 'LiquidDecimal':
          return 'number';
        default:
          return '';
      }
    },
    onInputFormTypeChanged(inputFormType) {
      this.inputFormType = inputFormType;
    },
    getInputForm() {
      if (this.$route.params.id != null) {
        // BASEURL
        const url = `/inputs/${this.$route.params.id}`;

        api.get(url)
          .then((response) => {
            this.inputForm = response.data;
          })
          .catch((error) => {
            console.log(error);
            this.$router.push({ name: 'input-form' });
          });
      }
    },
    foundInputByReference(inputForm) {
      this.inputForm = inputForm;
    },
    showSnackbar(message) {
      if (message.response) {
        if (message.response.status === 400) {
          this.snackbarMessage = message.response.data;
        } else {
          this.snackbarMessage = 'Something went wrong';
        }
      } else {
        this.snackbarMessage = message;
      }

      this.snackbar = true;
    },
  },
  watch: {
    '$route.params.id': {
      handler(id) {
        if (id == null) {
          // eslint-disable-next-line
          location.reload();
        }
      },
    },
  },
  created() {
    this.getInputFormTypes();
    this.getInputForm();
    this.getPorts();
    this.getEnums();
    this.getProducts();
    this.$eventHub.$on('found-input-by-reference', this.foundInputByReference);
    this.$eventHub.$on('show-snackbar', this.showSnackbar);
  },
};
